import Vue from 'vue'
import 'babel-polyfill'
import './plugins/axios'
import './plugins/filter.js'
import router from './router'
import App from './App.vue'
import Antd from 'ant-design-vue';
import { Cascader } from 'element-ui';
import 'ant-design-vue/dist/antd.css';
Vue.config.productionTip = false;

Vue.use(Antd);
Vue.use(Cascader);

Vue.config.productionTip = false



new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
